<template>
  <router-view class="router-view"/>
</template>

<script>
  export default {
    name: 'p_app',
    data () {
      return {
      }
    },
    methods: {

    },
    mounted () {

    }
  }
</script>

<style lang="less">
  body{
    width: 100vw;
    font-family: arial,宋体;
    // height: 100vh;
    // overflow-x: hidden;
    // overflow-y: auto;
    background: #ededed;
  }
  .router-view{
    // height: 100%;
    display: flex;
    flex-direction: column;
  }
</style>



// WEBPACK FOOTER //
// src/app.vue